/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';
import { PatchServiceProviderOrganizationRequest } from '../../models/patch-service-provider-organization-request';

export interface PatchServiceProviderOrganization$Params {

/**
 * The organization key
 */
  organizationKey: KeyType;
      body: PatchServiceProviderOrganizationRequest
}

export function patchServiceProviderOrganization(http: HttpClient, rootUrl: string, params: PatchServiceProviderOrganization$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, patchServiceProviderOrganization.PATH, 'patch');
  if (params) {
    rb.path('organizationKey', params.organizationKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

patchServiceProviderOrganization.PATH = '/service-provider/organizations/{organizationKey}';
